export default __webpack_public_path__ + "static/media/metro-warning-red.7d8416d2.svg";